import { definedOrThrow } from '@funnellab/shared/src/utils/definedOrThrow.ts';

const ENV: string = import.meta.env.VITE_ENV as string;
export const isTest = !!import.meta.env.TEST;
export const Environment = {
  ENV: ENV,

  isProd: ENV === 'prod',
  isDev: ENV === 'dev',

  DIRECTUS_API_URL: definedOrThrow(
    'VITE_DIRECTUS_API_URL',
    import.meta.env.VITE_DIRECTUS_API_URL as string,
  ),
  APP_URL: definedOrThrow('APP_URL', import.meta.env.VITE_APP_URL as string),
  // Facebook Tracking
  FBT_ID: definedOrThrow('VITE_FBT_ID', import.meta.env.VITE_FBT_ID as string),
  // TikTok Pixel
  TIKTOK_PIXEL_ID: definedOrThrow(
    'VITE_TIKTOK_PIXEL_ID',
    import.meta.env.VITE_TIKTOK_PIXEL_ID as string,
  ),
  // Google Tag Manager
  GTM_ID: definedOrThrow('GTM_ID', import.meta.env.VITE_GTM_ID as string),
  // Google Ads Tracking
  GAT_AGENCY_ID: definedOrThrow(
    'GAT_AGENCY_ID',
    import.meta.env.VITE_GAT_AGENCY_ID as string,
  ),
  GAT_AGENCY_JOBWIZARD_COMPLETED: definedOrThrow(
    'GAT_AGENCY_JOBWIZARD_COMPLETED',
    import.meta.env.VITE_GAT_AGENCY_JOBWIZARD_COMPLETED as string,
  ),
  GAT_AGENCY_REGISTRATION_COMPLETED: definedOrThrow(
    'GAT_AGENCY_REGISTRATION_COMPLETED',
    import.meta.env.VITE_GAT_AGENCY_REGISTRATION_COMPLETED as string,
  ),
  GAT_CHATBOT_ID: definedOrThrow(
    'GAT_CHATBOT_ID',
    import.meta.env.VITE_GAT_CHATBOT_ID as string,
  ),
  GAT_CHATBOT_COMPLETED: definedOrThrow(
    'GAT_CHATBOT_COMPLETED',
    import.meta.env.VITE_GAT_CHATBOT_COMPLETED as string,
  ),
  // LinkedIn Tracking
  LINKED_IN_PARTNER_ID: definedOrThrow(
    'VITE_LINKED_IN_PARTNER_ID',
    import.meta.env.VITE_LINKED_IN_PARTNER_ID as string,
  ),
  LINKED_IN_CHATBOT_COMPLETED: definedOrThrow(
    'VITE_LINKED_IN_CHATBOT_COMPLETED',
    import.meta.env.VITE_LINKED_IN_CHATBOT_COMPLETED as string,
  ),
  STRIPE_PUBLISHABLE_KEY: definedOrThrow(
    'VITE_STRIPE_PUBLISHABLE_KEY',
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
  ),
  LEAFLET_MAP_URL: definedOrThrow(
    'VITE_LEAFLET_MAP_URL',
    import.meta.env.VITE_LEAFLET_MAP_URL as string,
  ),
  MAPBOX_ACCESS_TOKEN: definedOrThrow(
    'VITE_MAPBOX_ACCESS_TOKEN',
    import.meta.env.VITE_MAPBOX_ACCESS_TOKEN as string,
  ),
  MAPBOX_STYLE_DE: definedOrThrow(
    'VITE_MAPBOX_STYLE_DE',
    import.meta.env.VITE_MAPBOX_STYLE_DE as string,
  ),
  MAPBOX_STYLE_EN: definedOrThrow(
    'VITE_MAPBOX_STYLE_EN',
    import.meta.env.VITE_MAPBOX_STYLE_EN as string,
  ),
  NETWORK_CHECK_INTERVAL: Number(
    definedOrThrow(
      'VITE_NETWORK_CHECK_INTERVAL',
      import.meta.env.VITE_NETWORK_CHECK_INTERVAL as string,
    ),
  ),
  IMGLY_LICENSE_KEY: definedOrThrow(
    'VITE_IMGLY_LICENSE_KEY',
    import.meta.env.VITE_IMGLY_LICENSE_KEY as string,
  ),
  CESDK_CORE_ASSETS_URL: definedOrThrow(
    'VITE_CESDK_CORE_ASSETS_URL',
    import.meta.env.VITE_CESDK_CORE_ASSETS_URL as string,
  ),
  CESDK_DEFAULT_RESOURCES_URL: definedOrThrow(
    'VITE_CESDK_DEFAULT_RESOURCES_URL',
    import.meta.env.VITE_CESDK_DEFAULT_RESOURCES_URL as string,
  ),
  RECAPTCHA_SITE_KEY: definedOrThrow(
    'VITE_RECAPTCHA_SITE_KEY',
    (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string) || 'failed to read key',
  ),
};
